import React from 'react';
import { Compass, LifeBuoy, Sprout, Users2 } from 'lucide-react';
import { PublicSection, PublicCard, Reveal } from '@/components/public';

const SUPPORT_AREAS = [
  {
    icon: <Compass className="w-5 h-5" />,
    title: 'Onboarding Guidance',
    description:
      "We'll help prepare your storefront and answer questions throughout the setup process.",
  },
  {
    icon: <LifeBuoy className="w-5 h-5" />,
    title: 'Platform Support',
    description:
      'Receive assistance with updates, configuration changes, and general platform questions.',
  },
  {
    icon: <Sprout className="w-5 h-5" />,
    title: 'Business Growth',
    description:
      'Explore opportunities to improve your storefront, promote seasonal campaigns, and strengthen your local presence.',
  },
  {
    icon: <Users2 className="w-5 h-5" />,
    title: 'Long-Term Partnership',
    description:
      'As Hungry Canadian evolves, participating businesses benefit from ongoing platform improvements and new capabilities.',
  },
];

/**
 * "Local Support From Real People" — section 7.
 */
export default function SupportResourcesSection() {
  return (
    <PublicSection
      id="support-resources"
      testId="join-support-resources"
      padTop="pt-10 md:pt-14"
      eyebrow="Local human support"
      title="Partnership doesn't end at launch."
      description="Launching your storefront is only the beginning. Hungry Canadian continues working alongside businesses after launch by providing guidance, platform support, and ongoing assistance as your business grows."
    >
      <div
        className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4"
        data-testid="support-areas-grid"
      >
        {SUPPORT_AREAS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.06}>
            <PublicCard
              icon={s.icon}
              title={s.title}
              description={s.description}
              interactive
              className="h-full"
              testId={`support-area-${s.title
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/(^-|-$)/g, '')}`}
            />
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div
          className="mt-14 md:mt-16 max-w-3xl mx-auto text-center"
          data-testid="support-closing-statement"
        >
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Our goal is to build lasting relationships with the businesses we
            work alongside by providing dependable support and practical
            technology that helps them serve their communities.
          </p>
        </div>
      </Reveal>
    </PublicSection>
  );
}
